import React, { useState, useEffect } from "react";
import { Routes, Route, useParams, Navigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import Start from "./start";
import PartySize from "./partySize";
import Contact from "./contact";
import Confirm from "./confirm";
import WaitingNumber from "./waitingNumber";
import CRMLogin from "./crm";
import { getWaitListByMerchantId, getMerchantByMerchantId } from "@/apis";
import { setWaitlist } from "@/store/slices/waitlist";
import { setMerchant } from "@/store/slices/merchant";
import { handleWaitlistOpenStatus } from "@/store/slices/waitlist";
import { useGlobalState } from "@/hooks/useGlobalState";

const useStyles = makeStyles({});

export default () => {
  const [language, setLanguage] = useGlobalState("language");

  useEffect(() => {
    const lsLang = localStorage.getItem("language");
    const actualLang = lsLang || window.navigator.language;
    setLanguage(actualLang);
  }, []);

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const classes = useStyles();
  const dispatch = useDispatch();
  const { merchantId } = useParams();
  const [firstload, setFirstload] = useState(false);
  const onLoad = async () => {
    const [merchant, waitlist] = await Promise.all([
      getMerchantByMerchantId(merchantId),
      getWaitListByMerchantId(merchantId),
    ]);
    dispatch(setMerchant(merchant.data));
    dispatch(setWaitlist({ list: waitlist.data }));
    const { businessHours, isOpen, timeZone } = merchant.data;
    dispatch(handleWaitlistOpenStatus(businessHours, isOpen, timeZone));
  };
  useEffect(() => {
    if (!firstload) {
      onFirstload();
    }
    async function onFirstload() {
      await onLoad();
      setFirstload(true);
    }
  }, []);
  return (
    <div className={classes.root}>
      <Routes>
        <Route path="start" element={<Start onLoad={onLoad} />} />
        <Route path="partySize" element={<PartySize />} />
        <Route path="contact" element={<Contact />} />
        <Route path="confirm" element={<Confirm />} />
        <Route path="crmLogin" element={<CRMLogin />} />
        <Route path="waitingNumber" element={<WaitingNumber />} />
        <Route path="*" element={<Navigate to="start" />} />
      </Routes>
    </div>
  );
};
